import {useState} from "react";
import {useDebouncedState} from "@mantine/hooks";
import DefaultTable from "../../components/DefaultTable";
import {IDevice} from "../../api/types";
import {useGetDevicesQuery} from "../../api/device";
import PageContainer from "../../components/PageContainer";

const Devices = () => {
    const [page, setPage] = useState(1)
    const [search, setSearch] = useDebouncedState('', 200);
    const {data = {content: [], totalPages: 0}, isFetching} = useGetDevicesQuery({page, pageSize: 10, search})

    function onRowClick(record: IDevice) {

    }

    return (
        <PageContainer>
            <DefaultTable
                data={data}
                columns={[
                    {name: 'serial', label: 'Серийный номер'},
                ]}
                onChangePage={setPage}
                isFetching={isFetching}
                page={page}
                onSearch={setSearch}
                enableSearch={true}
                searchPlaceholder={'Поиск по всем полям'}
                onRowClick={onRowClick}
            />
        </PageContainer>
    )
}

export default Devices;